import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import zh from "./zh.json";
import { STORAGE_UI } from "@/constants/storage";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "zh"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_UI.language,
      caches: ["localStorage"],
    },
  })
  .then(() => {
    // Keep <html lang> in sync — react-i18next doesn't touch it, so
    // a11y tooling (screen readers, automated translation, search
    // engines) would otherwise read the document as English even
    // when the UI is rendered in Chinese. Set on first init and on
    // every subsequent language change.
    const apply = (lng?: string) => {
      const tag = (lng ?? "en").startsWith("zh") ? "zh-Hans" : "en";
      if (typeof document !== "undefined") document.documentElement.lang = tag;
    };
    apply(i18n.language);
    i18n.on("languageChanged", apply);
  });

export default i18n;
